<template>
  <div>
    <v-dialog v-model="signatureConfirmDialog" max-width="600">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="white"
          style="width: 100%"
        >
          <h3 class="mb-4">
            {{
              $t(
                'Gostaria de assinar este checklist de segurança elétrica como validador?'
              )
            }}
          </h3>

          <v-divider></v-divider>
          <div class="d-flex justify-center">
            <v-radio-group v-model="option">
              <v-radio :value="0">
                <template v-slot:label>
                  <span class="black--text text-body-2">
                    {{ $t('Usar assinatura armazenada') }}
                  </span>
                </template>
              </v-radio>
              <v-radio :value="1">
                <template v-slot:label>
                  <span class="black--text text-body-2">
                    {{ $t('Assinar agora') }}
                  </span>
                </template>
              </v-radio>
            </v-radio-group>
          </div>

          <v-expand-transition>
            <div v-if="option == 1">
              <SignatureScreen v-model="validatorName" @save="sign" />
            </div>
          </v-expand-transition>

          <div v-if="option == 0" class="d-flex justify-space-between mt-2">
            <v-btn
              :disabled="loading"
              depressed
              class="ma-1 secondary-button"
              style="color: white; background-color: #b14949 !important"
              @click="signatureConfirmDialog = false"
            >
              {{ $t('Não') }}
            </v-btn>

            <v-btn
              :loading="loading"
              class="ma-1 primary-button"
              depressed
              color="#0F3582"
              style="color: white"
              @click="sign"
            >
              {{ $t('Sim') }}
            </v-btn>
          </div>
        </v-sheet>
      </div>
    </v-dialog>

    <v-card class="card-pad d-flex align-center mb-4">
      <v-row class="ma-0" dense>
        <v-col cols="12">
          <div class="my-3 d-flex justify-center align-center header">
            <img
              :src="'https://i.imgur.com/yItTg2c.png'"
              style="object-fit: cover; max-width: 50px"
            />
            <h1 class="ml-5">
              <strong class="text2" style="vertical-align: bottom">
                Checklist de
              </strong>
              <strong class="text1" style="vertical-align: bottom">
                {{ $t('Segurança elétrica') }}
              </strong>
            </h1>
          </div>
        </v-col>
      </v-row>
    </v-card>

    <v-card class="card-pad d-flex align-center mb-4">
      <v-row class="ma-0" dense>
        <strong class="ml-1">Dados gerais</strong>
        <v-col cols="12">
          <v-divider class="my-2"></v-divider>
        </v-col>

        <v-col cols="12" sm="6">
          <strong>{{ $t('Unidade') }}: </strong>
          <span> {{ payload.serviceOrder.unidade.name }}</span>
        </v-col>
        <v-col cols="12" sm="6">
          <strong>{{ $t('Endereço') }}: </strong>
          <span> {{ payload.serviceOrder.unidade.address }}</span>
        </v-col>
        <v-col cols="12" sm="6">
          <strong>{{ $t('Cidade/UF') }}: </strong>
          <span>
            {{
              payload.serviceOrder.unidade.city +
              `/` +
              payload.serviceOrder.unidade.state
            }}
          </span>
        </v-col>
        <v-col cols="12" sm="6">
          <strong>{{ $t('Setor') }}: </strong>
          <span> {{ payload.serviceOrder.equipment.department.name }}</span>
        </v-col>
        <v-col cols="12" sm="6">
          <strong>{{ $t('Sub-Setor') }}: </strong>
          <span>
            {{
              payload.serviceOrder.equipment.department.subDepartments ?? '---'
            }}</span
          >
        </v-col>
        <v-col cols="12" sm="6">
          <strong>{{ $t('Nº O.S.') }}: </strong>
          <span> {{ payload.serviceOrder.number }}</span>
        </v-col>
        <v-col cols="12" sm="6">
          <strong>{{ $t('Equipamento') }}: </strong>
          <span> {{ payload.serviceOrder.equipment.name }}</span>
        </v-col>
        <v-col cols="12" sm="6">
          <strong>{{ $t('Fabricante') }}: </strong>
          <span> {{ payload.serviceOrder.equipment.manufacturer }}</span>
        </v-col>
        <v-col cols="12" sm="6">
          <strong>{{ $t('Modelo') }}: </strong>
          <span> {{ payload.serviceOrder.equipment.model }}</span>
        </v-col>
        <v-col cols="12" sm="6">
          <strong>{{ $t('Identificação') }}: </strong>
          <span> {{ payload.serviceOrder.equipment.identification }}</span>
        </v-col>
        <v-col cols="12" sm="6">
          <strong>{{ $t('Código Patrimônio') }}: </strong>
          <span> {{ payload.serviceOrder.equipment.propertyCode }}</span>
        </v-col>
        <v-col cols="12" sm="6">
          <strong>{{ $t('Nº Serie:') }} </strong>
          <span> {{ payload.serviceOrder.equipment.serialNumber }}</span>
        </v-col>
      </v-row>
    </v-card>

    <v-card class="card-pad d-flex align-center mb-4">
      <v-row class="ma-0" dense>
        <strong class="ml-1">Rastreabilidade dos Padrões utilizadas</strong>
        <v-col cols="12">
          <v-divider class="my-2"></v-divider>
        </v-col>
        <v-col cols="12" sm="6">
          <strong>{{ $t('Padrão') }}: </strong>
          <span> {{ payload.pattern.name }}</span>
        </v-col>
        <v-col cols="12" sm="6">
          <strong>{{ $t('Fabricante') }}: </strong>
          <span> {{ payload.pattern.equipment.manufacturer }}</span>
        </v-col>
        <v-col cols="12" sm="6">
          <strong>{{ $t('Modelo') }}: </strong>
          <span> {{ payload.pattern.equipment.model }}</span>
        </v-col>
        <v-col cols="12" sm="6">
          <strong>{{ $t('Nº série') }}: </strong>
          <span> {{ payload.pattern.equipment.serialNumber }}</span>
        </v-col>
        <v-col cols="12" sm="6">
          <strong>{{ $t('Órgão calibrador') }}: </strong>
          <span> {{ payload.pattern.number }}</span>
        </v-col>
        <v-col cols="12" sm="6">
          <strong>{{ $t('Nº certificado') }}: </strong>
          <span> {{ payload.pattern.number }}</span>
        </v-col>
        <v-col cols="12" sm="6">
          <strong>{{ $t('Validade calibração') }}: </strong>
          <span> {{ formatDate(payload.pattern.expirationDate) }}</span>
        </v-col>
        <v-col cols="12" sm="6">
          <strong>{{ $t('Código patrimônio') }}: </strong>
          <span> {{ payload.pattern.equipment.propertyCode }}</span>
        </v-col>
      </v-row>
    </v-card>

    <v-card class="card-pad d-flex align-center mb-4">
      <v-row class="ma-0" dense>
        <v-col
          cols="12"
          v-for="checklist in payload.woFinished.checklists"
          :key="checklist.id"
        >
          <strong class="ml-1">{{ checklist.title }}</strong>
          <v-data-table
            :headers="headers"
            :items="checklist.fields"
            hide-default-footer
            disable-filtering
            disable-pagination
            class="main-table mb-6"
          >
            <template v-slot:item.condition="{ item }">
              {{ getConditionDisplay(item.condition) }}
            </template>
            <template v-slot:item.approved="{ item }">
              <v-chip :color="getColor(item)" dark small>{{
                getStatus(item)
              }}</v-chip>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="card-pad mb-4">
      <div class="d-flex flex-wrap">
        <div class="d-flex flex-wrap flex-column align-center text-center">
          <img
            style="max-width: 320px; max-height: 100px"
            class="my-4"
            :src="
              serviceOrder && serviceOrder.arkMedsChecklist.executorImage
                ? serviceOrder.arkMedsChecklist.executorImage
                : serviceOrder &&
                  serviceOrder.arkMedsChecklist.executingUser &&
                  serviceOrder.arkMedsChecklist.signatureImage
                ? serviceOrder.arkMedsChecklist.signatureImage
                : ''
            "
          />
          <span>{{ $t('Assinatura Técnico Executor') }}</span>
          <br />

          <span
            v-if="
              serviceOrder.arkMedsChecklist.executorImage == null &&
              serviceOrder.arkMedsChecklist.executorName == null
            "
            >{{
              serviceOrder.arkMedsChecklist.executingUser
                ? serviceOrder.arkMedsChecklist.executorName
                : $t('Sem registro')
            }}</span
          >

          <span v-if="serviceOrder.arkMedsChecklist.executorName">{{
            serviceOrder.arkMedsChecklist.executorName
          }}</span>

          <span
            class="d-block"
            v-if="
              serviceOrder?.arkMedsChecklist?.executingUser &&
              serviceOrder?.arkMedsChecklist?.executingUser
                .professionalRegistration
            "
          >
            {{ $t('Registro profissional:') }}
            {{
              serviceOrder.arkMedsChecklist.executingUser
                .professionalRegistration || 'Não informado'
            }}
          </span>
        </div>
        <v-spacer></v-spacer>

        <div class="d-flex flex-column align-center text-center fill-height">
          <img
            style="max-width: 320px; max-height: 100px"
            class="my-4"
            :src="
              signImage
                ? signImage
                : serviceOrder.arkMedsChecklist.validatorImage
            "
          />
          <span>Assinatura Responsável</span>
          <br />

          <span v-if="serviceOrder.arkMedsChecklist.validatorName">{{
            serviceOrder.arkMedsChecklist.validatorName
          }}</span>

          <span v-else>{{
            serviceOrder.arkMedsChecklist.validatorUser
              ? serviceOrder.arkMedsChecklist.validatorName
              : $t('Sem registro')
          }}</span>
          <span
            class="d-block"
            v-if="
              serviceOrder?.arkMedsChecklist?.validatorUser &&
              serviceOrder?.arkMedsChecklist?.validatorUser
                .professionalRegistration
            "
          >
            {{ $t('Registro profissional:') }}
            {{
              serviceOrder.arkMedsChecklist.validatorUser
                .professionalRegistration || 'Não informado'
            }}
          </span>
        </div>
      </div>

      <div class="mt-3 d-flex justify-center">
        <v-btn
          v-if="!hasValidatorSignature"
          depressed
          class="secondary-button ma-1"
          @click="signatureConfirmDialog = true"
        >
          {{ $t('Assinar') }}
        </v-btn>
        <v-btn
          v-else
          depressed
          class="secondary-button ma-1"
          @click="removeValidatorSignature"
        >
          {{ $t('Remover assinatura') }}
        </v-btn>
        <v-btn
          class="primary-button ma-1"
          depressed
          @click="generateElectricalSafetyChecklistPDF(serviceOrder)"
        >
          {{ $t('Imprimir') }}
        </v-btn>
      </div>
    </v-card>
  </div>
</template>
<script>
import ApiService from '../../../../services/ApiService'
import SignatureScreen from '../../../../components/SignatureScreen.vue'

export default {
  components: {
    SignatureScreen,
  },

  computed: {
    hasValidatorSignature() {
      const image = this.serviceOrder?.arkMedsChecklist?.validatorImage
      return !!image && image.trim() !== ''
    },
  },
  data() {
    return {
      payload: null,
      checklistItems: [],
      serviceOrder: null,
      signatureConfirmDialog: false,
      signImagePath: '',
      signImage: '',
      option: null,
      validatorName: '',
      user: {},
      headers: [
        {
          text: '',
          align: 'center',
          value: '',
          sortable: false,
        },
        {
          text: 'Descrição',
          align: 'center',

          value: 'title',
          sortable: false,
        },
        {
          text: 'Valor',
          align: 'center',

          value: 'value',
          sortable: false,
        },
        {
          text: 'Critério de aceitação',
          align: 'center',

          value: 'condition',
          sortable: false,
        },
        {
          text: 'Avaliação',
          align: 'center',

          value: 'approved',
          sortable: false,
        },
      ],
      apiService: new ApiService(),
      institution: {},
    }
  },
  async created() {
    const id = this.$route.params.id
    const response = await this.apiService.get(
      `arkmeds/webhooks/electricalSafetyData/${id}`
    )
    this.payload = response.content
    console.log('this.payload', this.payload)
    if (this.payload?.woFinished?.checklists?.length > 0) {
      this.checklistItems = this.payload.woFinished.checklists.flatMap(
        (x) => x.fields
      )
    }
    this.serviceOrder = this.payload.serviceOrder
    this.user = JSON.parse(localStorage.getItem('user'))
    console.log(this.user)
    this.institution = JSON.parse(localStorage.getItem('institution'))
  },
  methods: {
    formatDate(date) {
      return new Date(date).toLocaleDateString('pt-BR')
    },

    getStatus(item) {
      if (item.none_apply) return 'Não se aplica'
      if (item.approved) return 'Aprovado'
      return 'Reprovado'
    },

    getColor(item) {
      if (item.none_apply) return '#426483'
      if (item.approved) return '#BBCF20'
      return '#B14949'
    },

    getConditionDisplay(condition) {
      if (!condition) return '-'
      const parts = []
      if (condition.less_than != null)
        parts.push(`Menor que ${condition.less_than}`)
      if (condition.greater_than != null)
        parts.push(`Maior que ${condition.greater_than}`)
      return parts.join(' e ') || '-'
    },

    async generateElectricalSafetyChecklistPDF(serviceOrder) {
      try {
        const checklistId = serviceOrder.arkMedsChecklist.id
        const response = await this.apiService.post(
          `arkmeds/webhooks/generateElectricalSafetyPdf/${checklistId}`
        )

        if (response.statusCode === 200) {
          const pdfBase64 = response.message
          const pdfUrl = `data:application/pdf;base64,${pdfBase64}`

          const link = document.createElement('a')
          link.href = pdfUrl
          link.setAttribute(
            'download',
            `Checklist_${this.formatDate(new Date())}.pdf`
          )
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)

          this.$toast.success('PDF gerado! Já pode abrir 📄')
        } else {
          this.$toast.error('Falha ao gerar o PDF.')
        }
      } catch (error) {
        console.error('Erro ao gerar PDF:', error)
        this.$toast.error('Erro ao gerar o PDF.')
      }
    },

    sign(data) {
      if (this.option == 0) {
        if (this.user.signatureImage) {
          if (
            this.user.signatureImage.includes(
              'https://equipacarefix.blob.core.windows.net/'
            )
          ) {
            this.signImage = this.user.signatureImage
            this.signImagePath = this.user.signatureImage
          } else {
            this.signImage = `wwwroot/Uploads/Users/${this.user.id}/signatureImage`
            this.signImagePath = `${process.env.VUE_APP_BASE_URL}Uploads/Users/${this.user.id}/signatureImage/${this.user.signatureImage}`
          }

          this.signatureConfirmDialog = false
          this.validateChecklist()
        } else {
          this.$toast.error(
            'Assinatura não encontrada, verifique se existe uma assinatura cadastrada em seu usuário'
          )
        }
      } else {
        this.signImage = data
        this.signatureConfirmDialog = false
        this.validateChecklist()
      }
    },
    async validateChecklist() {
      if (!this.user || !this.user.id) {
        this.$toast.error('Usuário não encontrado.')
        return
      }

      const payload = {
        Id: this.serviceOrder.arkMedsChecklist.id,
        ValidatorUserId: this.user.id,
        ValidatorName: this.validatorName,
        ValidatorImage: this.signImage,
        CalibrationDate: new Date().toISOString(),
        IsValidatorSigned: true,
      }

      try {
        const response = await this.apiService.post(
          'arkmeds/webhooks/validate-electrical-safety',
          payload
        )

        if (response.statusCode === 200) {
          this.$toast.success('Checklist validado com sucesso!')
          this.signatureConfirmDialog = false
          this.serviceOrder.arkMedsChecklist.validatorImage = this.signImage
          this.serviceOrder.arkMedsChecklist.validatorName = this.validatorName
          this.serviceOrder.arkMedsChecklist.isValidatorSigned = true
          // ATUALIZA O OBJETO validatorUser LOCALMENTE
          this.serviceOrder.arkMedsChecklist.validatorUser = {
            ...this.user,
          }
        } else {
          this.$toast.error('Erro ao validar checklist.')
        }
      } catch (error) {
        this.$toast.error('Falha na validação.')
      }
    },
    async removeValidatorSignature() {
      let valid = false

      if (
        this.institution.userType == 2 ||
        this.user.mainType == 1 ||
        this.institution.userType == 8 ||
        this.user.mainType == 0
      ) {
        valid = true
      }

      if (this.user.id == this.payload.validatorUserId) {
        valid = true
      }

      if (valid) {
        this.signImage = ''
        this.signImagePath = ''
        this.validatorName = ''
        this.validatorUserId = ''

        this.payload.isValidatorSigned = false
        this.payload.validatorUserId = null
        this.payload.validatorName = null
        this.payload.validatorUserId = null

        const payload = {
          Id: this.serviceOrder.arkMedsChecklist.id,
          ValidatorUserId: null,
          ValidatorName: null,
          ValidatorImage: null,
          CalibrationDate: null,
          IsValidatorSigned: false,
        }

        try {
          const response = await this.apiService.post(
            'arkmeds/webhooks/validate-electrical-safety',
            payload
          )

          if (response.statusCode === 200) {
            this.$toast.success('Assinatura removida com sucesso!')
            this.serviceOrder.arkMedsChecklist.validatorImage = null
            this.serviceOrder.arkMedsChecklist.validatorName = null
            this.serviceOrder.arkMedsChecklist.isValidatorSigned = false
            this.serviceOrder.arkMedsChecklist.validatorUserId = null
            // LIMPA O OBJETO validatorUser LOCALMENTE
            this.serviceOrder.arkMedsChecklist.validatorUser = null
          } else {
            this.$toast.error('Erro ao remover assinatura.')
          }
        } catch (error) {
          this.$toast.error('Falha ao remover a assinatura.')
        }
      } else {
        this.$toast.error(
          'Você não tem permissão para remover esta assinatura.'
        )
      }
    },
  },
}
</script>
<style scoped>
.text1 {
  color: #426483;
}

.text2 {
  color: #bbcf20;
}
</style>
